module.exports = __webpack_public_path__ + "static/restaurant_dbk02-e541063dc8fa8f76eedf522365e31e32.jpg";